export interface Invoice {
  id: string;
  branch_id: string;
  sale_order_id: string | null;
  customer_id: string;
  customer_fiscal_profile_id: string | null;
  folio_number: string | null;
  series: string | null;
  serie_external: string | null;
  folio_external: string | null;
  status:
    | 'pending'
    | 'stamping'
    | 'stamped'
    | 'cancel_requested'
    | 'cancelled'
    | 'cancel_failed'
    | 'failed';
  uuid: string | null;
  pac_provider: string;
  subtotal_cents: string;
  tax_cents: string;
  total_cents: string;
  currency: string;
  cfdi_usage: string | null;
  payment_method_code: string | null;
  payment_form_code: string | null;
  tax_regime: string | null;
  postal_code: string | null;
  rfc_emisor: string | null;
  rfc_receptor: string | null;
  legal_name_receptor: string | null;
  error_message: string | null;
  requested_at: string;
  stamped_at: string | null;
  cancelled_at: string | null;
  cancel_reason_code: string | null;
  cancel_substitution_uuid: string | null;
  created_at: string;
}

export interface FiscalProfile {
  id: string;
  customer_id: string;
  label: string | null;
  rfc: string;
  legal_name: string;
  tax_regime_code: string;
  postal_code: string;
  street: string | null;
  exterior_number: string | null;
  interior_number: string | null;
  neighborhood: string | null;
  municipality: string | null;
  state: string | null;
  cfdi_usage: string;
  email: string | null;
  is_default: boolean;
  status: 'active' | 'inactive';
}

export type InvoiceStatusFilter =
  | ''
  | 'pending'
  | 'stamping'
  | 'stamped'
  | 'cancel_requested'
  | 'cancelled'
  | 'cancel_failed'
  | 'failed';

export const INVOICE_STATUS_VALUES: readonly Exclude<InvoiceStatusFilter, ''>[] = [
  'pending',
  'stamping',
  'stamped',
  'cancel_requested',
  'cancelled',
  'cancel_failed',
  'failed',
];
